export default [

  {
    path: '/vacuumAccountInfo',
    name: 'vacuumAccountInfo',
    component: () => import('./views/accountInfo/index.vue'),
    meta: {
      title: '账户信息',
      permissionCode: '2660'
    }
  },
  {
    path: '/vacuumOrderInfo',
    name: 'vacuumOrderInfo',
    component: () => import('./views/orderInfo/index.vue'),
    meta: {
      title: '订单信息',
      permissionCode: '2661'
    }
  },
  {
    path: '/vacuumRechargeRefundInfo',
    name: 'vacuumRechargeRefundInfo',
    component: () => import('./views/rechargeRefundInfo/index.vue'),
    meta: {
      title: '充值退款信息',
      permissionCode: '2662'
    }
  },
  {
    path: '/vacuumFinancialStatistics',
    name: 'vacuumFinancialStatistics',
    component: () => import('./views/financialStatistics/index.vue'),
    meta: {
      title: '财务统计报表',
      permissionCode: '2663'
    }
  },
  {
    path: '/vacuumOrderDayReport',
    name: 'vacuumOrderDayReport',
    component: () => import('./views/orderDayReport/index.vue'),
    meta: {
      title: '订单日报表',
      permissionCode: '2664'
    }
  }
]
